import { CarouselExperimentProduct } from './types';

export const generateCarouselProductsList = (
  productsList: CarouselExperimentProduct[],
  clickHandler: () => void,
) => {
  const carouselList = productsList.map((product, idx) => ({
    id: `${product.item}-${idx}`,
    title: product.brand,
    description: product.item,
    onClick: clickHandler,
    imageUrl: product.imageUrl,
    variant: 'product' as const,
    price: +product.msrp,
  }));

  return carouselList;
};
